import React from "react";
import { Globe } from "lucide-react";

const LOGO_URL =
  "https://customer-assets-gfyr7b9c.emergentagent.net/job_42d720e7-30a4-4a3b-a2a8-13624538fe77/artifacts/xpq8sdnc_Emira%20Manpower%20and%20Training%20Solutions%20Logo.png";

// variant: "image" (full color logo on light bg) | "light" (white text for dark bg)
export function Logo({ variant = "image", className = "", showTagline = false }) {
  if (variant === "image") {
    return (
      <div className={`flex items-center ${className}`} data-testid="emira-logo">
        <img src={LOGO_URL} alt="Emira Manpower" className="h-11 w-auto object-contain" />
      </div>
    );
  }
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="emira-logo">
      <div className="grid place-items-center h-10 w-10 rounded-xl bg-[#0088FF] text-white">
        <Globe className="h-6 w-6" strokeWidth={2.2} />
      </div>
      <div className="leading-none">
        <div className="font-display font-extrabold tracking-tight text-white text-xl">EMIRA</div>
        {showTagline && (
          <div className="text-[10px] uppercase tracking-[0.18em] text-sky-300/80 mt-0.5">
            Manpower &amp; Training
          </div>
        )}
      </div>
    </div>
  );
}
